import React from "react";
import { Box } from "@mui/material";
import { CONFIG } from "@frontend/config";
import { useTranslation } from "react-i18next";

interface ChatLocationProps {
  latLong: string;
  size?: 'regular' | 'compact';
}

export const ChatLocation: React.FC<ChatLocationProps> = ({ latLong, size = 'regular' }) => {
  const { t } = useTranslation();
  const [lat, lng] = latLong.split('|').map(coord => parseFloat(coord.trim()));
  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=300x200&maptype=roadmap&markers=color:red%7Clabel:A%7C${lat},${lng}&key=${CONFIG.GOOGLE_KEY}`;

  const dims = size === 'compact'
    ? { maxW: 220, maxH: 140 }
    : { maxW: 300, maxH: 200 };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={1}
    >
      <Box
        component="img"
        src={staticMapUrl}
        alt={t('whatsapp.location')}
        sx={{
          maxWidth: dims.maxW,
          maxHeight: dims.maxH,
          objectFit: "contain",
          borderRadius: 1,
          cursor: "pointer"
        }}
        onClick={() => {
          const url = `https://maps.google.com/?q=${lat},${lng}`;
          window.open(url, '_blank');
        }}
      />
    </Box>
  );
}; 
